export default __webpack_public_path__ + "images/a843be16e51440547ca16871179bd1fe-parking.webp";